import { render } from "./CanadaTwoEight.vue?vue&type=template&id=3f349312&scoped=true"
import script from "./CanadaTwoEight.vue?vue&type=script&lang=js"
export * from "./CanadaTwoEight.vue?vue&type=script&lang=js"

import "./CanadaTwoEight.vue?vue&type=style&index=0&id=3f349312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f349312"]])

export default __exports__